// extracted by mini-css-extract-plugin
module.exports = {"p":"header_p__lqxAP","name":"header_name__1A1QR"};